export const environment = {
  production: false,
  //apiUrl: 'http://localhost:5135' 
  apiUrl: 'https://ticketapi.dev-limprod.com'
};